import { Page, Text, View, Document, StyleSheet, pdf, Image, Link } from '@react-pdf/renderer'
import { FsOFAOverall, FsOFAValue } from '../../shared/model/models'
import { fsColors } from '../../shared/constants'
import {
  DiversityDimension,
  DiversityDimenstionConfig,
  Module,
  ModuleConfig,
} from '../../shared/model'

import FinalMoney from '../../assets/ofa/Final_Money.png'
import OFALogoPay from '../../assets/ofa/OFA_logo_Pay.png'
import OFALogoCareer from '../../assets/ofa/OFA_logo_Career.png'
import OFALogoTime from '../../assets/ofa/OFA_logo_Time.png'
import OFALogoTraining from '../../assets/ofa/OFA_logo_Training.png'

import CompanyLogo from '../../assets/company/Logo.png'

import PGPayGender from '../../assets/ofa/pg/Pay-Gender.png'
import PGPayDisability from '../../assets/ofa/pg/Pay-Disability.png'
import PGPayOrigin from '../../assets/ofa/pg/Pay-Origin.png'
import PGPayAge from '../../assets/ofa/pg/Pay-Age.png'
import PGCareerGender from '../../assets/ofa/pg/Career-Gender.png'
import PGCareerDisability from '../../assets/ofa/pg/Career-Disability.png'
import PGCareerOrigin from '../../assets/ofa/pg/Career-Origin.png'
import PGCareerAge from '../../assets/ofa/pg/Career-Age.png'
import PGTimeGender from '../../assets/ofa/pg/Time-Gender.png'
import PGTimeDisability from '../../assets/ofa/pg/Time-Disability.png'
import PGTimeOrigin from '../../assets/ofa/pg/Time-Origin.png'
import PGTimeAge from '../../assets/ofa/pg/Time-Age.png'
import PGTrainingDisability from '../../assets/ofa/pg/Training-Disability.png'
import PGTrainingGender from '../../assets/ofa/pg/Training-Gender.png'
import PGTrainingOrigin from '../../assets/ofa/pg/Training-Origin.png'
import PGTrainingAge from '../../assets/ofa/pg/Training-Age.png'

import BalanceGender from '../../assets/ofa/balance/Balance-Gender.png'
import BalanceDisability from '../../assets/ofa/balance/Balance-Disability.png'
import BalanceOrigin from '../../assets/ofa/balance/Balance-Origin.png'
import BalanceAge from '../../assets/ofa/balance/Balance-Age.png'

import CoinsGender from '../../assets/ofa/coins/Coins-Gender.png'
import CoinsDisability from '../../assets/ofa/coins/Coins-Disability.png'
import CoinsOrigin from '../../assets/ofa/coins/Coins-Origin.png'
import CoinsAge from '../../assets/ofa/coins/Coins-Age.png'

import EmpsGender from '../../assets/ofa/groups/Emps-Gender.png'
import EmpsDisability from '../../assets/ofa/groups/Emps-Disability.png'
import EmpsOrigin from '../../assets/ofa/groups/Emps-Origin.png'
import EmpsAge from '../../assets/ofa/groups/Emps-Age.png'

import IllusGender from '../../assets/ofa/illus/Gender.png'
import IllusDisability from '../../assets/ofa/illus/Disability.png'
import IllusOrigin from '../../assets/ofa/illus/Origin.png'
import IllusAge from '../../assets/ofa/illus/Age.png'

import FAIRLogo from '../../assets/Logo_FAIR.png'
import { translatedDomainName, getFormattedString } from '../../shared/utils'

const styles = StyleSheet.create({
  companyLogo: {
    margin: '88px',
    height: '46.5px',
    width: 'auto',
    objectFit: 'contain',
    objectPosition: 'top left',
  },
  overallImg: {
    width: '30px',
    height: '25px',
    objectFit: 'contain',
    objectPosition: 'center',
    marginRight: '8px',
  },
  coverPhoto: {
    height: '700px',
    position: 'absolute',
    bottom: '148px',
    right: '88px',
    objectFit: 'contain',
    objectPosition: 'bottom right',
  },
  pageGuide: {
    position: 'absolute',
    width: '64px',
    objectFit: 'contain',
    objectPosition: 'top right',
    top: 0,
    right: 0,
  },
  pageNumber: {
    position: 'absolute',
    bottom: 70,
    right: 15,
  },
  section: {
    width: '100%',
    padding: '40px 60px',
  },
  bodyText: {
    fontFamily: 'Raleway',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: 0,
    textAlign: 'justify',
  },
  bodyTextBold: {
    fontFamily: 'RalewayBold',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: 0,
  },
})

const Illustration = {
  [DiversityDimension.GENDER]: IllusGender,
  [DiversityDimension.DISABILITY]: IllusDisability,
  [DiversityDimension.ORIGIN]: IllusOrigin,
  [DiversityDimension.MIGRATION_BACKGROUND]: IllusOrigin,
  [DiversityDimension.AGE]: IllusAge,
}

const CoverPage = {
  [Module.PAY]: OFALogoPay,
  [Module.CAREER]: OFALogoCareer,
  [Module.WORKING_TIME]: OFALogoTime,
  [Module.TRAINING]: OFALogoTraining,
}

const PageGuide = {
  [Module.PAY]: {
    [DiversityDimension.GENDER]: PGPayGender,
    [DiversityDimension.DISABILITY]: PGPayDisability,
    [DiversityDimension.ORIGIN]: PGPayOrigin,
    [DiversityDimension.MIGRATION_BACKGROUND]: PGPayOrigin,
    [DiversityDimension.AGE]: PGPayAge,
  },
  [Module.CAREER]: {
    [DiversityDimension.GENDER]: PGCareerGender,
    [DiversityDimension.DISABILITY]: PGCareerDisability,
    [DiversityDimension.ORIGIN]: PGCareerOrigin,
    [DiversityDimension.MIGRATION_BACKGROUND]: PGCareerOrigin,
    [DiversityDimension.AGE]: PGCareerAge,
  },
  [Module.WORKING_TIME]: {
    [DiversityDimension.GENDER]: PGTimeGender,
    [DiversityDimension.DISABILITY]: PGTimeDisability,
    [DiversityDimension.ORIGIN]: PGTimeOrigin,
    [DiversityDimension.MIGRATION_BACKGROUND]: PGTimeOrigin,
    [DiversityDimension.AGE]: PGTimeAge,
  },
  [Module.TRAINING]: {
    [DiversityDimension.GENDER]: PGTrainingGender,
    [DiversityDimension.DISABILITY]: PGTrainingDisability,
    [DiversityDimension.ORIGIN]: PGTrainingOrigin,
    [DiversityDimension.MIGRATION_BACKGROUND]: PGTrainingOrigin,
    [DiversityDimension.AGE]: PGTrainingAge,
  },
}

const OverallImgs = {
  [DiversityDimension.GENDER]: [BalanceGender, CoinsGender, EmpsGender],
  [DiversityDimension.DISABILITY]: [BalanceDisability, CoinsDisability, EmpsDisability],
  [DiversityDimension.ORIGIN]: [BalanceOrigin, CoinsOrigin, EmpsOrigin],
  [DiversityDimension.MIGRATION_BACKGROUND]: [BalanceOrigin, CoinsOrigin, EmpsOrigin],
  [DiversityDimension.AGE]: [BalanceAge, CoinsAge, EmpsAge],
}

export const downloadOFAGuide = async (
  values: FsOFAValue[],
  overall: FsOFAOverall,
  goiName: string,
  rgName: string,
  t: any,
  i18n: any,
  date: Date,
  cwiMappings: Record<
    string,
    { kldb20105: string; titleKldb: string; bezeichnungKldb: string }[]
  > | null,
  moduleConfig?: ModuleConfig,
  diversityDimenstionConfig?: DiversityDimenstionConfig,
  trainingCost?: number,
) => {
  const currentDate = new Date()
  const module = moduleConfig?.module ?? Module.PAY
  const divdim = diversityDimenstionConfig?.diversityDimension ?? DiversityDimension.GENDER
  const ddName = t(`context.model.name.${divdim}`)
  const mName = t(`module.name.${module}`)
  const isCareerModule = module === Module.CAREER

  const TableRow = (row: FsOFAValue) => {
    const backgroundColor =
      Number(Number(row.newGap).toFixed(1)) !== 0.0
        ? fsColors.fsGray.colors[2]
        : fsColors.fsGray.colors[3]
    return (
      <View
        key={`row_${row.id}`}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-start',
          justifyContent: 'center',
          width: '100%',
          marginTop: '4px',
        }}
        wrap={false}
      >
        <View
          style={{
            width: isCareerModule ? '20%' : '10%',
            height: '100%',
            padding: '10px',
            backgroundColor,
            marginRight: '4px',
            borderRadius: '4px',
          }}
        >
          <Text style={styles.bodyText}>
            {isCareerModule
              ? translatedDomainName(row.ofaVariableLabel, t)
              : parseInt(row.ofaVariableLabel, 10)}
          </Text>
        </View>
        <View
          style={{
            width: '10%',
            height: '100%',
            padding: '10px',
            backgroundColor,
            marginRight: '4px',
            borderRadius: '4px',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Text
            style={{
              color:
                Number(row.actualGap) > 5
                  ? '#d32f2f'
                  : Number(row.actualGap) > 2.5
                  ? '#ed6c02'
                  : '#0288d1',
              fontSize: '20px',
              marginRight: '4px',
            }}
          >{`\u2022`}</Text>
          <Text style={styles.bodyText}>
            {getFormattedString(i18n.language, row.actualGap, 1, 1)} %
          </Text>
        </View>
        <View
          style={{
            width: '10%',
            height: '100%',
            padding: '10px',
            backgroundColor,
            marginRight: '4px',
            borderRadius: '4px',
          }}
        >
          <Text
            style={styles.bodyText}
          >{`${row.totalEmployeesConcerned} / ${row.totalEmployeesConsidered}`}</Text>
        </View>
        {!isCareerModule && (
          <View
            style={{
              width: '15%',
              height: '100%',
              padding: '10px',
              backgroundColor,
              marginRight: '4px',
              borderRadius: '4px',
            }}
          >
            <Text style={styles.bodyText}>
              {`${getFormattedString(i18n.language, row.currentCmAverage, 2, 2)} ${t(
                `${moduleConfig?.unit}`,
              )}`}
            </Text>
          </View>
        )}
        {row.newGap === null ? (
          <View
            style={{
              width: isCareerModule ? '60%' : '55%',
              height: '100%',
              padding: '10px',
              backgroundColor,
              marginLeft: '12px',
              marginRight: '0px',
              borderRadius: '4px',
            }}
          >
            <Text style={styles.bodyText}>{t('no.action.desc', { goi_name: goiName })}</Text>
          </View>
        ) : (
          <>
            <View
              style={{
                width: '10%',
                height: '100%',
                padding: '10px',
                backgroundColor,
                marginRight: '4px',
                borderRadius: '4px',
              }}
            >
              <Text style={styles.bodyText}>{`${getFormattedString(
                i18n.language,
                row.newGap,
                1,
                1,
              )} %`}</Text>
            </View>
            <View
              style={{
                width: isCareerModule ? '20%' : '15%',
                height: '100%',
                padding: '10px',
                backgroundColor,
                marginRight: '4px',
                borderRadius: '4px',
              }}
            >
              <Text style={styles.bodyText}>
                {isCareerModule
                  ? getFormattedString(i18n.language, row?.additionalCmAverage ?? '', 0, 0, true)
                  : `${getFormattedString(
                      i18n.language,
                      row?.additionalCmAverage ?? '',
                      2,
                      2,
                      true,
                    )} ${t(`${moduleConfig?.unit}`)}`}
              </Text>
            </View>
            <View
              style={{
                width: '20%',
                height: '100%',
                padding: '10px',
                backgroundColor,
                marginRight: '4px',
                borderRadius: '4px',
              }}
            >
              <Text style={styles.bodyText}>{`${getFormattedString(
                i18n.language,
                row?.additionalCost ?? '',
                2,
                2,
                true,
              )} \u20ac`}</Text>
            </View>
            <View
              style={{
                width: '10%',
                height: '100%',
                padding: '10px',
                backgroundColor,
                borderRadius: '4px',
              }}
            >
              <Text style={styles.bodyText}>{`${getFormattedString(
                i18n.language,
                row?.costAsPercentageOfPayroll ?? '',
                0,
                3,
              )} %`}</Text>
            </View>
          </>
        )}
      </View>
    )
  }

  const TextBold = (text: string, style = {}) => (
    <Text
      style={{
        ...styles.bodyTextBold,
        textAlign: 'center',
        ...style,
      }}
    >
      {text}
    </Text>
  )

  const Footer = (
    <View
      style={{
        ...styles.section,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: `2px solid ${moduleConfig?.fsColor.primary}`,
        paddingTop: '20px',
        paddingBottom: '20px',
        position: 'absolute',
        bottom: 0,
      }}
      fixed
    >
      <Text style={styles.bodyTextBold}>
        {currentDate.toLocaleDateString(i18n.language === 'en' ? 'en-US' : 'de-DE', {
          month: 'long',
          year: 'numeric',
          day: '2-digit',
        })}
      </Text>
      <View style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Text style={styles.bodyText}>Powered by</Text>
          <Image
            src={FAIRLogo}
            style={{ height: '43px', objectFit: 'contain', marginLeft: '8px' }}
          />
        </View>
        <Link src="www.ines-analytics.com" style={{ ...styles.bodyText, color: '#000' }}>
          www.ines-analytics.com
        </Link>
      </View>
    </View>
  )

  const Template = (
    <Document>
      <Page size="A4" orientation="landscape" dpi={150}>
        <Image src={CompanyLogo} style={styles.companyLogo} />
        <Text
          style={{
            ...styles.bodyTextBold,
            color: moduleConfig?.fsColor.primary,
            fontSize: '42px',
            marginLeft: '88px',
            textTransform: 'uppercase',
          }}
        >
          {t('options.for.action')}
        </Text>
        <Text
          style={{
            ...styles.bodyTextBold,
            color: moduleConfig?.fsColor.primary,
            fontSize: '80px',
            marginLeft: '88px',
            marginTop: '8px',
          }}
        >
          {mName} {t('by')} {ddName}
        </Text>
        <Text
          style={{
            ...styles.bodyTextBold,
            color: moduleConfig?.fsColor.primary,
            fontSize: '24px',
            marginTop: '8px',
            marginLeft: '88px',
          }}
        >
          {`${translatedDomainName(goiName, t)} vs. ${translatedDomainName(rgName, t)}`}
        </Text>
        <Text
          style={{
            ...styles.bodyTextBold,
            color: moduleConfig?.fsColor.primary,
            fontSize: '24px',
            marginTop: '8px',
            marginLeft: '88px',
          }}
        >
          {`${t('data.from')} ${date.toLocaleDateString(
            i18n.language === 'en' ? 'en-US' : 'de-DE',
            {
              month: 'long',
              year: 'numeric',
              day: '2-digit',
            },
          )}`}
        </Text>
        <Image src={CoverPage[module]} style={styles.coverPhoto} />
        {Footer}
      </Page>
      <Page size="A4" orientation="landscape" dpi={150}>
        <View style={{ ...styles.section }}>
          <Image src={PageGuide[module][divdim]} style={styles.pageGuide} />
          <Text
            style={{
              ...styles.bodyTextBold,
              color: diversityDimenstionConfig?.fsColor.primary,
              fontSize: '60px',
            }}
          >
            {t('ofa.guide.overall')}
          </Text>
        </View>

        <View style={styles.section}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'stretch',
              justifyContent: 'center',
            }}
          >
            <View
              style={{
                border: `2px solid ${diversityDimenstionConfig?.fsColor.primary}`,
                padding: '16px',
                borderRadius: '6px',
                width: '30%',
                marginRight: '16px',
              }}
            >
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginBottom: '24px',
                }}
              >
                <Image src={OverallImgs[divdim][0]} style={styles.overallImg} />
                <Text
                  style={{
                    ...styles.bodyTextBold,
                    fontSize: '20px',
                  }}
                >
                  {`${t('unadjusteder')} ${t(`${moduleConfig?.module}_gap`)} ${t(
                    'ofa.after.actions',
                  )}`}
                </Text>
              </View>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Text
                  style={{
                    ...styles.bodyTextBold,
                    textAlign: 'center',
                    fontSize: '40px',
                    marginBottom: '16px',
                  }}
                >
                  {getFormattedString(i18n.language, `${overall.overallGap}`, 1, 1)} %
                </Text>

                <Text
                  style={{
                    ...styles.bodyTextBold,
                    textAlign: 'center',
                  }}
                >
                  {`${t('ofa.current')}: ${getFormattedString(
                    i18n.language,
                    `${overall.currentOverallGap}`,
                    1,
                    1,
                  )} %`}
                </Text>
              </View>
            </View>
            <View
              style={{
                border: `2px solid ${diversityDimenstionConfig?.fsColor.primary}`,
                padding: '16px',
                borderRadius: '6px',
                width: '30%',
                marginRight: '16px',
              }}
            >
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginBottom: '24px',
                }}
              >
                <Image src={OverallImgs[divdim][1]} style={styles.overallImg} />
                <Text
                  style={{
                    ...styles.bodyTextBold,
                    fontSize: '20px',
                  }}
                >
                  {t('ofa.additional.wage')}
                </Text>
              </View>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Text
                  style={{
                    ...styles.bodyTextBold,
                    textAlign: 'center',
                    fontSize: '40px',
                    marginBottom: '16px',
                  }}
                >
                  {`${getFormattedString(
                    i18n.language,
                    `${overall.additionalCost}`,
                    2,
                    2,
                    true,
                  )} \u20ac/${t('ofa.month')}`}
                </Text>

                <Text
                  style={{
                    ...styles.bodyTextBold,
                    textAlign: 'center',
                  }}
                >
                  {`${getFormattedString(i18n.language, `${overall.percentOfPayroll}`, 0, 2)} % ${t(
                    'ofa.current.monthly',
                  )}`}
                </Text>
              </View>
            </View>
            {!isCareerModule && (
              <View
                style={{
                  border: `2px solid ${diversityDimenstionConfig?.fsColor.primary}`,
                  padding: '16px',
                  borderRadius: '6px',
                  width: '30%',
                }}
              >
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: '24px',
                  }}
                >
                  <Image src={OverallImgs[divdim][2]} style={styles.overallImg} />
                  <Text
                    style={{
                      ...styles.bodyTextBold,
                      fontSize: '20px',
                    }}
                  >
                    {t('ofa.no.of.employees')}
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Text
                    style={{
                      ...styles.bodyTextBold,
                      textAlign: 'center',
                      fontSize: '40px',
                      marginBottom: '16px',
                    }}
                  >
                    {getFormattedString(i18n.language, `${overall.employeesConsidered}`, 0, 0)}{' '}
                    {t('ofa.employees')}
                  </Text>

                  <Text
                    style={{
                      ...styles.bodyTextBold,
                      textAlign: 'center',
                    }}
                  >
                    {`${getFormattedString(
                      i18n.language,
                      `${overall.percentEmployeesConsidered}`,
                      0,
                      2,
                    )} % ${t('ofa.all.employees')}`}
                  </Text>
                </View>
              </View>
            )}
          </View>
          {trainingCost && (
            <Text
              style={{ ...styles.bodyText, marginTop: '6px', fontSize: '14px', fontWeight: 'bold' }}
            >
              *{' '}
              {t('ofa.assumption.cost', {
                cost: trainingCost.toLocaleString(i18n.language, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }),
              })}
            </Text>
          )}
          <Text style={{ ...styles.bodyText, marginTop: '32px' }}>
            {t(isCareerModule ? 'ofa.guide.career.gap.desc' : 'ofa.guide.gap.desc', {
              module: t(`${moduleConfig?.module}_gap`),
              dimension: ddName,
              gap: getFormattedString(i18n.language, `${overall.currentOverallGap}`, 1, 1),
              new_gap: getFormattedString(i18n.language, `${overall.overallGap}`, 1, 1),
              group: goiName,
              costs: getFormattedString(i18n.language, `${overall.additionalCost}`, 2, 2),
              percent: getFormattedString(i18n.language, `${overall.percentOfPayroll}`, 0, 2),
            })}
          </Text>
        </View>

        <View
          style={{
            ...styles.section,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '0px',
            position: 'absolute',
            bottom: '105px',
          }}
        >
          <Image src={Illustration[divdim]} style={{ width: '600px', objectFit: 'contain' }} />

          <Text
            style={{
              ...styles.bodyTextBold,
              color: diversityDimenstionConfig?.fsColor.primary,
              marginTop: '20px',
              fontSize: '20px',
            }}
          >
            {t('ofa.tag.line', { module: `${t(`overview.heading.${module}`)}` })}
          </Text>
        </View>
        {Footer}
        <View
          style={styles.pageNumber}
          render={({ pageNumber }) => (
            <View>
              <Text style={styles.bodyText}>{pageNumber - 1}</Text>
            </View>
          )}
        />
      </Page>
      <Page
        size="A4"
        orientation="landscape"
        dpi={150}
        style={{ paddingBottom: '120px', paddingTop: '60px' }}
      >
        <Image src={PageGuide[module][divdim]} style={styles.pageGuide} fixed />
        <View style={styles.section}>
          <View style={{ paddingLeft: '60px', paddingRight: '60px' }}>
            <View style={{ marginBottom: '40px' }}>
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  width: '100%',
                  borderBottom: `1px solid ${fsColors.fsGray.colors[2]}`,
                }}
              >
                {isCareerModule ? (
                  <>
                    <View style={{ width: '20%', height: '100%', padding: '10px' }}>
                      <Text style={styles.bodyTextBold}>{t('ofa.career.level')}</Text>
                    </View>
                    <View style={{ width: '10%', height: '100%', padding: '10px' }}>
                      <Text style={styles.bodyTextBold}>{t('ofa.header.cur.gap')}</Text>
                    </View>
                    <View style={{ width: '10%', height: '100%', padding: '10px' }}>
                      <Text style={styles.bodyTextBold}>{t('ofa.header.cur.emp')}</Text>
                    </View>
                    <View
                      style={{
                        width: '10%',
                        height: '100%',
                        padding: '10px',
                        backgroundColor: fsColors.fsGray.colors[2],
                      }}
                    >
                      <Text style={styles.bodyTextBold}>{t('ofa.header.new.gap')}</Text>
                    </View>
                    <View
                      style={{
                        width: '20%',
                        height: '100%',
                        padding: '10px',
                        backgroundColor: fsColors.fsGray.colors[2],
                      }}
                    >
                      <Text style={styles.bodyTextBold}>{t('ofa.header.new.emp')}</Text>
                    </View>
                    <View
                      style={{
                        width: '20%',
                        height: '100%',
                        padding: '10px',
                        backgroundColor: fsColors.fsGray.colors[2],
                      }}
                    >
                      <Text style={styles.bodyTextBold}>{`${t('ofa.header.add')} ${t(
                        'ofa.header.monthly.cost',
                      )}`}</Text>
                    </View>
                    <View
                      style={{
                        width: '10%',
                        height: '100%',
                        padding: '10px',
                        backgroundColor: fsColors.fsGray.colors[2],
                      }}
                    >
                      <Text style={styles.bodyTextBold}>{t('ofa.header.pct.cost')}</Text>
                    </View>
                  </>
                ) : (
                  <>
                    <View style={{ width: '10%', height: '100%', padding: '10px' }}>
                      <Text style={styles.bodyTextBold}>{t('ofa.header.cwi')}</Text>
                    </View>
                    <View style={{ width: '10%', height: '100%', padding: '10px' }}>
                      <Text style={styles.bodyTextBold}>{t('ofa.header.cur.gap')}</Text>
                    </View>
                    <View style={{ width: '10%', height: '100%', padding: '10px' }}>
                      <Text style={styles.bodyTextBold}>{t('ofa.no.of.employees')}</Text>
                    </View>
                    <View style={{ width: '15%', height: '100%', padding: '10px' }}>
                      <Text style={{ ...styles.bodyTextBold }}>{`${t('ofa.header.avg')} ${t(
                        moduleConfig?.unit ?? '',
                      )}`}</Text>
                    </View>
                    <View
                      style={{
                        width: '10%',
                        height: '100%',
                        padding: '10px',
                        backgroundColor: fsColors.fsGray.colors[2],
                      }}
                    >
                      <Text style={styles.bodyTextBold}>{t('ofa.header.new.gap')}</Text>
                    </View>
                    <View
                      style={{
                        width: '15%',
                        height: '100%',
                        padding: '10px',
                        backgroundColor: fsColors.fsGray.colors[2],
                      }}
                    >
                      <Text style={styles.bodyTextBold}>{`${t('ofa.header.add')} ${t(
                        'ofa.header.avg',
                      )} ${t(moduleConfig?.unit ?? '')}`}</Text>
                    </View>
                    <View
                      style={{
                        width: '20%',
                        height: '100%',
                        padding: '10px',
                        backgroundColor: fsColors.fsGray.colors[2],
                      }}
                    >
                      <Text style={styles.bodyTextBold}>{`${t('ofa.header.add')} ${t(
                        'ofa.header.monthly.cost',
                      )}`}</Text>
                    </View>
                    <View
                      style={{
                        width: '10%',
                        height: '100%',
                        padding: '10px',
                        backgroundColor: fsColors.fsGray.colors[2],
                      }}
                    >
                      <Text style={styles.bodyTextBold}>{t('ofa.header.pct.cost')}</Text>
                    </View>
                  </>
                )}
              </View>
              {values.map((v) => TableRow(v))}
            </View>
          </View>

          <View
            style={{
              backgroundColor: moduleConfig?.fsColor.colors[3],
              padding: '24px 80px',
              borderRadius: '10px',
              marginLeft: '58px',
              marginRight: '58px',
              marginBottom: '-60px',
            }}
            wrap={false}
          >
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Image
                src={FinalMoney}
                style={{ width: '90px', objectFit: 'contain', marginRight: '20px' }}
              />
              <View
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {TextBold(
                  i18n.language === 'de'
                    ? 'Zusätzliche monatliche Lohnkosten'
                    : 'Additional monthly wage',
                )}
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {TextBold(
                    i18n.language === 'de' ? 'für diese Maßnahme' : 'costs for this action',
                  )}
                </View>
                <View
                  style={{
                    width: '100%',
                    border: '1px solid black',
                    backgroundColor: 'black',
                    marginVertical: '8px',
                  }}
                />
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {TextBold(
                    i18n.language === 'de'
                      ? 'Aktuelle Gesamtlohnkosten'
                      : 'Current total wage costs',
                  )}
                </View>
              </View>
              {TextBold('x', { marginTop: '18px' })}
              {TextBold('100', { marginTop: '18px' })}
              {TextBold('=', { fontSize: '40px', marginTop: '11px' })}
              <View
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: '18px',
                }}
              >
                {TextBold(
                  `${getFormattedString(i18n.language, `${overall.additionalCost}`, 2, 2)} \u20ac/${
                    i18n.language === 'de' ? 'Monat' : 'month'
                  }`,
                )}
                <View
                  style={{
                    width: '100%',
                    border: '1px solid black',
                    backgroundColor: 'black',
                    marginVertical: '8px',
                  }}
                />
                {TextBold(
                  `${getFormattedString(
                    i18n.language,
                    `${overall.totalMonthlyPayroll}`,
                    1,
                    1,
                  )} \u20ac/${i18n.language === 'de' ? 'Monat' : 'month'}`,
                )}
              </View>
              {TextBold('x', { marginTop: '18px' })}
              {TextBold('100', { marginTop: '18px' })}
              {TextBold('=', { fontSize: '40px', marginTop: '11px' })}
              <View
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {TextBold(
                  i18n.language === 'de' ? 'Anstieg der monatlichen' : 'Monthly wage costs',
                  { marginBottom: '4px' },
                )}
                {TextBold(i18n.language === 'de' ? 'Lohnkosten in %' : 'increase in %', {
                  marginBottom: '12px',
                })}
                {TextBold(
                  `${getFormattedString(i18n.language, `${overall.percentOfPayroll}`, 0, 2)} %`,
                  {
                    fontSize: '30px',
                  },
                )}
              </View>
            </View>
          </View>
        </View>
        <View style={styles.section}>
          <View style={{ paddingLeft: '60px', paddingRight: '60px' }}>
            <Text
              style={{
                ...styles.bodyTextBold,
                marginTop: '16px',
              }}
            >
              {t('etrl.kpi.occ.inc')}
            </Text>
          </View>
          {cwiMappings && !isCareerModule
            ? Object.entries(cwiMappings).map(([key, value]) => (
                <View
                  style={{ paddingLeft: '60px', paddingRight: '60px', marginTop: '24px' }}
                  wrap={false}
                >
                  <View
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      width: '100%',
                    }}
                  >
                    <View style={{ width: '20%' }}>
                      <Text style={{ ...styles.bodyTextBold, marginLeft: '8px' }}>
                        {`${t('ofa.header.cwi')}: ${parseInt(key, 10)}`}
                      </Text>
                    </View>
                    <View style={{ width: '88%', marginLeft: '8px' }}>
                      <Text style={styles.bodyTextBold}> </Text>
                    </View>
                  </View>
                  <View
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      marginTop: '16px',
                      width: '100%',
                    }}
                  >
                    <View style={{ width: '12%', textAlign: 'center' }}>
                      <Text style={{ ...styles.bodyTextBold, textAlign: 'center' }}>
                        {t('pt.assistance.selected.occ.kldb')}
                      </Text>
                    </View>
                    <View style={{ width: '88%', marginLeft: '8px' }}>
                      <Text style={styles.bodyTextBold}>
                        {t('pt.assistance.selected.occ.main')}
                      </Text>
                    </View>
                  </View>
                  {value.map((vv) => (
                    <View
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'flex-start',
                        justifyContent: 'flex-start',
                        width: '100%',
                        marginTop: '8px',
                      }}
                    >
                      <View style={{ width: '12%', textAlign: 'center' }}>
                        <Text style={{ ...styles.bodyText, textAlign: 'center' }}>
                          {vv.kldb20105}
                        </Text>
                      </View>
                      <View style={{ width: '88%', marginLeft: '8px' }}>
                        <Text style={styles.bodyText}>
                          {i18n.language === 'de' ? vv.bezeichnungKldb : vv.titleKldb}
                        </Text>
                      </View>
                    </View>
                  ))}
                </View>
              ))
            : null}
        </View>
        {Footer}
        <View
          fixed
          style={styles.pageNumber}
          render={({ pageNumber }) => (
            <View>
              <Text style={styles.bodyText}>{pageNumber - 1}</Text>
            </View>
          )}
        />
      </Page>
    </Document>
  )
  const blob = await pdf(Template).toBlob()

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = data
  link.download = `${mName}_${t('by')}_${ddName}`

  // this is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    }),
  )

  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
    link.remove()
  }, 100)
  return null
}
